import MicroModal from "micromodal";

var navigation = document.querySelector(".navigation--fixed");
if (navigation) {
  let menu = document.querySelector(".navigation__menu");
  let menuLinks = document.querySelectorAll(".navigation__link");
  let dropdowns = document.querySelectorAll(
    ".navigation-submenu.dropdown-pane"
  );
  let line = document.querySelector(".navigation__menu-line");

  if (line) {
    menuLinks.forEach(function(element) {
      element.addEventListener(
        "mouseenter",
        function(event) {
          var offsetLeft = document
            .querySelector(".navigation__menu-bar")
            .getBoundingClientRect().left;
          var spanElement = event.target.querySelector("span");
          line.style.width = spanElement.getBoundingClientRect().width + "px";
          line.style.left =
            spanElement.getBoundingClientRect().left - offsetLeft + "px";
        },
        false
      );
    });

    menu.addEventListener(
      "mouseleave",
      function(event) {
        var dropdown = document.querySelector(".navigation-submenu.is-open");
        if (!dropdown) {
          line.style.width = 0;
        }
      },
      false
    );

    if (dropdowns.length > 0) {
      dropdowns.forEach(function(element) {
        element.addEventListener(
          "mouseleave",
          function(event) {
            line.style.width = 0;
          },
          false
        );
      });
    }
  }

  var navigationScrollListener = debounce(function() {
    if (line) line.style.width = 0;
    var navigation_submenu = null;
    if ((navigation_submenu = $(".navigation-submenu")).length) {
      navigation_submenu.foundation("close");
    }
  }, 40);

  window.addEventListener("scroll", navigationScrollListener);

  $(window).scroll(() => {
    if (window.scrollY >= 120) {
      navigation.classList.add("navigation--sticky");
    } else {
      navigation.classList.remove("navigation--sticky");
    }
  });
}

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

$(document).ready(function() {
  $(".button.button--homepage-cta").each(function(e) {
    if (
      $(this)
        .text()
        .toLowerCase()
        .trim() == "request access"
    ) {
      $(this).attr("href", "/trial-access/");
    }
  });

  $("#request-access-form").on("submit", function(event) {
    event.preventDefault();

    return false;
  });

  $("#request-access-form").on("forminvalid.zf.abide", function(ev, frm) {
    let invalid = $(frm)
      .find(".is-invalid-input")
      .first();

    if (invalid) {
    }
  });

  $("#request-access-form").on("formvalid.zf.abide", function(ev, frm) {
    $("#btn-request-access").html("Sending ...");
    $("#btn-request-access").prop("disabled", true);

    const params = new FormData(document.querySelector("#request-access-form"));

    const form = document.createElement("form");
    form.style.display = "none";
    form.setAttribute("method", "POST");
    form.setAttribute(
      "action",
      "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
    );

    for (const key of params.keys()) {
      const hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params.get(key));
      console.log(key, params.get(key));
      form.appendChild(hiddenField);
    }

    document.body.appendChild(form);

    form.addEventListener("submit", function() {
      setTimeout(function() {
        window.location.assign("/trial-access/thank-you");
      }, 1000);
    });

    form.submit();

    // $.ajax({
    //   type: 'POST',
    //   url: $(frm).attr('action'),
    //   data: $(frm).serialize(),
    //   cache       : false,
    //   contentType : "charset=utf-8",
    //   error       : function(err) {
    //     $('#btn-request-access').html('Failed!');
    //   },
    //   success     : function(data) {

    //     if(data.result == "error"){

    //       if(data.msg.search('is already subscribed') == -1){
    //         $('#btn-request-access').html('Failed!');
    //         return false;
    //       }

    //     }

    //     setTimeout(function(){
    //       window.location.assign('/trial-access/thank-you')
    //     },1000);

    //   },
    //   complete: function(){
    //     setTimeout(function(){
    //       $('#btn-request-access').html('Get Started');
    //       $('#btn-request-access').prop('disabled',false);
    //     },3000);
    //   }
    // });
  });
});
